// Small status chips on achievement cards: the collectible face and history.

import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { cn } from '@/utilities/cn';
import type {
  AchievementAccent,
  AchievementReward,
} from '@airhead-games/shared/types';
import { trackPaletteStyle } from './trackPalette';

const CHIP_CLASS =
  'inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold';

// Later: other reward types (e.g. access to a game) get their own label here.
export const rewardLabel = (reward: AchievementReward): string =>
  `${reward.amount.toLocaleString()} ${reward.amount === 1 ? 'Loon' : 'Loons'}`;

export const RewardChip: React.FC<{
  reward: AchievementReward;
  accent: AchievementAccent | null;
  level: number;
}> = ({ reward, accent, level }) => (
  <span
    style={trackPaletteStyle(accent, level)}
    className={cn(
      CHIP_CLASS,
      'bg-(--lvl-100) text-(--lvl-800) dark:bg-(--lvl-900) dark:text-(--lvl-200)'
    )}
  >
    <GiftIcon className="size-3.5" />
    {rewardLabel(reward)}
  </span>
);

// Tinted with the text color, so it shows on any neutral surface (a card or
// a complete track's muted face).
export const CompletedChip: React.FC = () => (
  <span className={cn(CHIP_CLASS, 'bg-foreground/10 text-foreground')}>
    <CheckIcon className="size-3.5" strokeWidth={3} />
    Completed
  </span>
);
